export default "__VITE_ASSET__CGlvoh$y__"